import React, { useState, useEffect, useContext, useMemo } from "react";
import { useDidUpdate } from "../../../../hooks/useUpdate";
import axios from "../../../../axios/index";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import { Form } from "react-bootstrap";
import { Checkbox } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
// import ModalLimitCheck from './ModalLimitCheck';
import DeleteConsultantModal from "./DeleteConsultantModal";

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
// import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import deleteIconRed from "./../../../../assets/img/DashboardICons/TrashIcon.svg";
import CVDownloadGreen from "./../../../../assets/img/DashboardICons/CVDwonloadGreen.svg";
import DeleteIcon_Rounded from "./../../../../assets/img/DashboardICons/DeleteIcon_Rounded.svg";

import places from "../../DashboardReuseAbleComponents/AddNewFiles/places";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import { FormControlLabel } from "@mui/material";
import { IOSSwitch } from "../../DashboardArchivedFiles/ArchiveDetail/IOSSwitch";

const StaffColleaguesInfoCardDetail = () => {
  const [userData, setUserData] = useState({
    id: "",
    name: "",
    fullName: "",
    family: "",
    gender: "",
    numberId: "",
    callNumber: "",
    email: "",
    joinDate: "",
    isActive: true,
    isShowEstates: true,
  });
  const { userToken, permissions } = useContext(UserContext);
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const history = useHistory();
  // Modal State
  const [showModal, setShowModal] = useState({
    openProfile: false,
    openLimitation: false,
    openRemove: false,
  });
  const [cursor, setCursor] = useState("pointer");
  // Form State
  const [formStaffColleaguesInfo, setFormStaffColleaguesInfo] = useState({
    id: "",
    fullName: state?.name + " " + state?.family,
    education: "",
    position: "",
    positionID: "",
    callNumber: "",
    email: "",
    address: "",
    formBirthDateUpdate: false,
    formRegistryDateUpdate: false,
    CV: undefined,
    aboutMe: "",
    nationalId: "",
    formBirthDate: "",
    formRegistryDate: "",
    imageUrl: "",
    landlinePhone: "",
  });
  const [roles, setRoles] = useState();
  // Check Area And Accsess Level State
  const [checkStaffArea, setCheckStaffArea] = useState(places);
  const [categories, setCategories] = useState([]);

  const [accessibleAreas, setAccessibleAreas] = useState([]);

  useMemo(() => formStaffColleaguesInfo, [formStaffColleaguesInfo]);

  useEffect(() => {
    const dataHandler = async () => {
      const getConsultant = await axios.get(state?.fullName ? `Consultant/GetConsultantByUserId/${state?.id}` : `Consultant/GetConsultantById/${state?.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });

      const getCategories = await axios.get("Category", {
        headers: { authorization: "Bearer " + userToken },
      });
      const updatedData = getCategories.data.data?.map(item => ({
        ...item,
        selected: getConsultant.data.data.accessibleCategories?.some(selectedItem => selectedItem.key === item.id),
      }));
      setCategories(updatedData);

      const getUsersPermissions = await axios.get(`Users/${getConsultant.data.data.userId}`, {
        headers: { authorization: "Bearer " + userToken },
      });

      const userDataRes = await getUsersPermissions.data.data;

      setUserData(prev => {
        return {
          ...prev,
          id: userDataRes.id,
          fullName: userDataRes.fullName,
          name: userDataRes.name,
          family: userDataRes.family,
          callNumber: userDataRes.phoneNumber,
          email: userDataRes.email,
          joinDate: userDataRes?.createDate,
          isActive: userDataRes?.isActive,
          isShowEstates: userDataRes?.isShowEstates,
          gender: userDataRes?.gender,
        };
      });

      const getRoles = await axios.get("Role");
      const roleItems = getRoles.data.data;
      const updatedArray = await roleItems.map((item, index) => {
        return {
          ...item,
          isCheck: false,
        };
      });
      const addedRoles = await getUsersPermissions.data.data.roles;

      const updatedRoles = await updatedArray?.map(role => {
        const permission = addedRoles.find(p => p.roleTitle === role.title);
        if (permission) {
          return { ...role, isCheck: true };
        }
        return role;
      });
      setRoles(updatedRoles);

      const consultant = getConsultant.data.data;

      const position = updatedRoles?.find(item => item.title === "سوپر یوزر" && item.isCheck === true)
        ? "سوپر یوزر"
        : updatedRoles?.find(item => item.title === "مشاور" && item.isCheck === true)
        ? "مشاور"
        : updatedRoles?.find(item => item.title === "سرپرست" && item.isCheck === true)
        ? "سرپرست"
        : "";

      setFormStaffColleaguesInfo(prev => {
        return {
          ...prev,
          id: consultant.userId,
          education: consultant.education,
          callNumber: consultant.phoneNumber,
          email: consultant.email,
          address: consultant.address,
          CV: consultant.cvImageName,
          aboutMe: consultant.aboutMe,
          nationalId: consultant.nationalId,
          formBirthDate: consultant.birthDate,
          formRegistryDate: consultant.registerDate,
          imageUrl: consultant.imageUrl,
          landlinePhone: consultant.landlinePhone,
          position: position,
        };
      });
      setAccessibleAreas(consultant.accessibleAreas);
      setIsLoading(false);
    };

    dataHandler();
  }, [state?.id, userToken, state]);

  useDidUpdate(() => {
    setCheckStaffArea(prevState =>
      prevState.map(item => {
        const match = accessibleAreas.find(limit => limit.value === item.name);
        if (match) {
          return { ...item, isCheck: true };
        }
        return item;
      })
    );
  }, [accessibleAreas]);

  const parentCategories = categories?.filter(category => category.parentId === null);
  const categoryList = parentCategories.map(parent => {
    const childCategories = categories.filter(category => category.parentId === parent.id);
    return (
      <div key={parent.id}>
        <div className={`text-right ${styles.text_check_area_box}`}>{parent.title}</div>
        {childCategories.map(item => (
          <div key={item.id} className={`w-auto d-flex align-items-center justify-content-start ${styles.total_form_check_are_box}`}>
            <Checkbox
              checked={item.selected}
              onClick={() => statusCheckAreaHandler(item.id, "category")}
              inputProps={{ "aria-label": "controlled" }}
              size="medium"
            />

            <div className={`text-right ${styles.text_check_area_box}`}>{item.title}</div>
          </div>
        ))}
      </div>
    );
  });

  return (
    <>
      <style>
        {`
                    .rmdp-input {
                        color: #363636;
                        font-size: 16px;
                        border: 1px solid #e1e1e1;
                        border-radius: 100px;
                        height: auto;
                        padding: 11px 15px;
                        box-sizing: border-box;
                        transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                        box-shadow: none;
                        width: 100%;
                    }
                    .rmdp-input:focus {
                        border-color: #21409a;
                        box-shadow: none;
                    }
                    .rmdp-wrapper {
                        width: 100% !important;
                        box-shadow: none !important;
                        border: 1px solid #e1e1e1;
                        border-radius: 24px;
                    }
                    .rmdp-wrapper input {
                        font-size: 24px !important;
                        width: 45px !important;
                        color: #363636 !important;
                    }
                    .dvdr{
                        font-size: 35px !important;
                        color: #D9D9D9 !important;
                    }
                    .dropdown-toggle {
                        width: 100% !important;
                        height: 47.6px !important;
                        text-align: right !important;
                        color: #363636;
                        font-size: 16px;
                        background-color: #ffffff !important;
                        border: 1px solid #e1e1e1;
                        border-radius: 24px;
                        height: auto;
                        padding: 11px 15px;
                        box-sizing: border-box;
                        transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }

                    .dropdown-toggle.show {
                        border-color: #21409a !important;
                    }
                    
                    .dropdown-toggle:after,
                    .btn-info:after {
                        content: none;
                    }
                
                    .btn-info {
                        color: #1D1D1D !important;
                        box-shadow: none !important;
                    }

                    .dropdown-menu {
                        width: 100% !important;
                        height: 190px !important;
                        overflow-y: scroll;
                        background: #FFFFFF;
                        border: 1px solid #E1E1E1;
                        border-radius: 24px;
                    }

                    .dropdown-toggle:hover {
                        background: #f4f4f4;
                        color: #1D1D1D;
                        border-color: #e5e5e5;
                        border: 1px solid #e2e2e2;
                    }
                
                   .dropdown-menu::-webkit-scrollbar{
                    width: 3px;
                    height: 50px;
                    }
                    
                    .dropdown-menu::-webkit-scrollbar-track {
                        background: transparent;
                        margin-block: 10px;
                    }
                
                    .dropdown-menu::-webkit-scrollbar-thumb {
                        background: #B4B4B4;
                        border-radius: 20px;
                    }
                
                    .dropdown-item {
                        margin: .5rem 0;
                        padding: .5rem .5rem .5rem 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                
                    .dropdown-item:hover {
                        background: #E7EAF4 !important;
                        border-radius: 24px !important;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                    `}
      </style>

      {/* <ModalLimitCheck
                show={showModal.openLimitation}
                onHide={() => setShowModal((prev) => {
                    return { ...prev, openLimitation: false };
                })}
            /> */}

      <ShowProfileModal
        show={showModal.openProfile}
        onHide={() =>
          setShowModal(prev => {
            return { ...prev, openProfile: false };
          })
        }
      />

      <DeleteConsultantModal
        show={showModal.openRemove}
        onHide={() =>
          setShowModal(prev => {
            return { ...prev, openRemove: false };
          })
        }
        id={state?.id}
      />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 px-0 pb-4 ${styles.file_cards_container}`}>
                <DashboardHeader
                  onClick={() =>
                    setShowModal(prev => {
                      return { ...prev, openProfile: true };
                    })
                  }
                  class="px-0"
                />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>{formStaffColleaguesInfo.fullName}</div>
                  </div>
                </div>

                {/* Staff Colleagues Info Details */}

                <div dir="rtl" className={`text-right mx-4 px-4 ${styles.total_staff_colleagues_detail_box}`}>
                  <div className={`pb-5 position-relative`}>
                    <div className={`d-flex justify-content-between align-items-center`}>
                      <div className={`w-100 d-flex justify-content-between align-items-center flex-wrap ${styles.head_staff_colleagues_box}`}>
                        <div className={`d-flex justify-content-start align-items-center`}>
                          <img
                            className={`${styles.image_staff_colleagues_detail}`}
                            loading="lazy"
                            src={`https://backdev.azrmelk.com${formStaffColleaguesInfo.imageUrl}`}
                            alt="avatar"
                          />
                          <div className={`me-3`}>
                            <h4 className={`pb-2 ${styles.title_head_staff_colleagues_box}`}> {formStaffColleaguesInfo.fullName} </h4>
                            {roles?.find(item => item.title === "سوپر یوزر" && item.isCheck === true) ? (
                              <div
                                className={`d-flex align-items-center justify-content-md-center justify-content-between flex-wrap mb-0 ${styles.subTitle_head_staff_colleagues_box}`}
                                style={{ fontWeight: "600" }}>
                                سوپر یوزر
                                {/*checkStaffArea?.map((item, i) => (
                                                                        item.isCheck
                                                                            ? (
                                                                                <div key={i} className='mx-1' style={{
                                                                                    fontWeight: "400"
                                                                                }}>{item.name}</div>
                                                                            )
                                                                            : null
                                                                    ))*/}
                              </div>
                            ) : roles?.find(item => item.title === "مشاور" && item.isCheck === true) ? (
                              <div
                                className={`d-flex align-items-center justify-content-md-center justify-content-between flex-wrap mb-0 ${styles.subTitle_head_staff_colleagues_box}`}
                                style={{ fontWeight: "600" }}>
                                مشاور
                                {/*checkStaffArea?.map((item, i) => (
                                                                            item.isCheck
                                                                                ? (
                                                                                    <div key={i} className='mx-1' style={{
                                                                                        fontWeight: "400"
                                                                                    }}>{item.name}</div>
                                                                                )
                                                                                : null
                                                                        ))*/}
                              </div>
                            ) : (
                              roles?.find(item => item.title === "سرپرست" && item.isCheck === true) && (
                                <div
                                  className={`d-flex align-items-center justify-content-md-center justify-content-between flex-wrap mb-0 ${styles.subTitle_head_staff_colleagues_box}`}
                                  style={{ fontWeight: "600" }}>
                                  سرپرست
                                  {/*checkStaffArea?.map((item, i) => (
                                                                            item.isCheck
                                                                                ? (
                                                                                    <div key={i} className='mx-1' style={{
                                                                                        fontWeight: "400"
                                                                                    }}>{item.name}</div>
                                                                                )
                                                                                : null
                                                                        ))*/}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                        {/* <div className={`me-auto ${styles.limit_text_staff_colleagues_detail}`} role="button" onClick={() => setShowModal((prev) => {
                                                        return { ...prev, openLimitation: true };
                                                    })}>
                                                        محدود سازی فایل
                                                        <img className="p-2" src={arrowBlue} alt="arrow-left-blue" width="32" />
                                                    </div> */}
                      </div>
                    </div>

                    <div className={`d-flex justify-content-between align-items-start flex-wrap mt-4 mb-2 pt-4 pb-1`}>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="fullName">
                          {" "}
                          نام و نام‌خانوادگی{" "}
                        </Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" value={formStaffColleaguesInfo.fullName} />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="birthDate">
                          {" "}
                          تاریخ تولد{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          value={formStaffColleaguesInfo.formBirthDate?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="education">
                          {" "}
                          تحصیلات{" "}
                        </Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" value={formStaffColleaguesInfo.education} />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="position">
                          {" "}
                          سمت{" "}
                        </Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" value={formStaffColleaguesInfo.position} />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="registryDate">
                          {" "}
                          تاریخ عضویت{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          value={formStaffColleaguesInfo.formRegistryDate?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="callNumber">
                          {" "}
                          شماره تماس{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="tel"
                          value={formStaffColleaguesInfo.callNumber?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="landlinePhone">
                          {" "}
                          شماره تلفن ثابت{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="tel"
                          value={formStaffColleaguesInfo.landlinePhone?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="email">
                          {" "}
                          ایمیل{" "}
                        </Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="email" value={formStaffColleaguesInfo.email} />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="address">
                          {" "}
                          آدرس{" "}
                        </Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" value={formStaffColleaguesInfo.address} />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`}> رزومه </Form.Label>
                        <div
                          className={`${styles.form_control_input} shadow-none text-center`}
                          role="button"
                          onClick={handleDownload}
                          style={{ cursor: cursor }}>
                          <img src={CVDownloadGreen} alt="cv-download-icon" />
                          <span className={`pe-2 ${styles.form_text_cv_download}`}> دانلود رزومه </span>
                        </div>
                      </Form.Group>
                    </div>

                    {permissions?.find(item => item === 15) === 15 && (
                      <>
                        <div className={`mt-4 mb-5 pt-3`}>
                          <div className={`mb-3 pb-2`}>
                            <h5 className={`mb-0 ${styles.title_check_area_box}`}>انتخاب دسته بندی</h5>
                          </div>

                          <div className={`d-flex align-items-center justify-content-start flex-wrap`}>
                            {categories?.map(item =>
                              item.selected ? (
                                <div
                                  key={item.id}
                                  className={`d-flex align-items-center justify-content-between my-1 ms-2 py-1 px-2 ${styles.total_correct_checked_box}`}>
                                  <span className={`${styles.title_correct_checked_box}`}> {item.title} </span>
                                  <img
                                    className={`me-3`}
                                    src={DeleteIcon_Rounded}
                                    alt="delete-icon-rounded"
                                    role="button"
                                    onClick={() => deleteCheckAreaHandler(item.id, "category")}
                                  />
                                </div>
                              ) : null
                            )}
                          </div>

                          <Form.Group className={`${styles.total_form_group} mt-3 mb-4 pt-2 pb-1 d-flex flex-column w-100`}>
                            <Form.Label className={`${styles.form_label_input} pb-1`}> انتخاب دسته بندی </Form.Label>
                            <div className={`${styles.form_control_input} shadow-none d-flex align-items-start gap-2 justify-content-start flex-wrap`}>
                              {categoryList}
                            </div>
                          </Form.Group>
                        </div>

                        <div className={`mt-4 mb-5 pt-3`}>
                          <div className={`mb-3 pb-2`}>
                            <h5 className={`mb-0 ${styles.title_check_area_box}`}>انتخاب منطقه مشاوره</h5>
                          </div>

                          <div className={`d-flex align-items-center justify-content-start flex-wrap`}>
                            {checkStaffArea.map(item =>
                              item.isCheck ? (
                                <div
                                  key={item.id}
                                  className={`d-flex align-items-center justify-content-between my-1 ms-2 py-1 px-2 ${styles.total_correct_checked_box}`}>
                                  <span className={`${styles.title_correct_checked_box}`}> {item.name} </span>
                                  <img
                                    className={`me-3`}
                                    src={DeleteIcon_Rounded}
                                    alt="delete-icon-rounded"
                                    role="button"
                                    onClick={() => deleteCheckAreaHandler(item.id, "places")}
                                  />
                                </div>
                              ) : null
                            )}
                          </div>

                          <Form.Group className={`${styles.total_form_group} mt-3 mb-4 pt-2 pb-1 d-flex flex-column w-100`}>
                            <Form.Label className={`${styles.form_label_input} pb-1`}> انتخاب منطقه </Form.Label>
                            <div className={`${styles.form_control_input} shadow-none d-flex align-items-center justify-content-start flex-wrap`}>
                              {checkStaffArea.map(item => (
                                <div key={item.id} className={`d-flex align-items-center justify-content-start ${styles.total_form_check_are_box}`}>
                                  <Checkbox
                                    checked={item.isCheck}
                                    onClick={() => statusCheckAreaHandler(item.id, "places")}
                                    inputProps={{ "aria-label": "controlled" }}
                                    size="medium"
                                  />

                                  <div className={`text-right ${styles.text_check_area_box}`}>{item.name}</div>
                                </div>
                              ))}
                            </div>
                          </Form.Group>
                        </div>

                        <div className={`mt-4 mb-5 pt-3`}>
                          <div className={`mb-3 pb-2`}>
                            <h5 className={`mb-0 ${styles.title_check_area_box}`}>انتخاب سمت</h5>
                          </div>

                          <div className={`d-flex align-items-center justify-content-start flex-wrap`}>
                            {roles?.map(item =>
                              item.isCheck ? (
                                <div
                                  key={item.id}
                                  className={`d-flex align-items-center justify-content-between my-1 ms-2 py-1 px-2 ${styles.total_correct_checked_box}`}>
                                  <span className={`${styles.title_correct_checked_box}`}> {item.title} </span>
                                  <img
                                    className={`me-3`}
                                    src={DeleteIcon_Rounded}
                                    alt="delete-icon-rounded"
                                    role="button"
                                    onClick={() => deleteRoleCheckAreaHandler(item.id)}
                                  />
                                </div>
                              ) : null
                            )}
                          </div>

                          <Form.Group className={`${styles.total_form_group} mt-3 mb-4 pt-2 pb-1 d-flex flex-column w-100`}>
                            <Form.Label className={`${styles.form_label_input} pb-1`}> انتخاب سمت </Form.Label>
                            <div className={`${styles.form_control_input} shadow-none d-flex align-items-center justify-content-start flex-wrap`}>
                              {roles?.map(item => (
                                <div key={item.id} className={`d-flex align-items-center justify-content-start ${styles.total_form_check_are_box}`}>
                                  <Checkbox
                                    checked={item.isCheck}
                                    onClick={() => statusRoleCheckAreaHandler(item.id)}
                                    inputProps={{ "aria-label": "controlled" }}
                                    size="medium"
                                  />

                                  <div className={`text-right ${styles.text_check_area_box}`}>{item.title}</div>
                                </div>
                              ))}
                            </div>
                          </Form.Group>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            // justifyContent: "space-between",
                            gap: "70px",
                            alignItems: "center",
                          }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "10px",
                            }}>
                            <FormControlLabel
                              sx={{ m: 0 }}
                              onChange={event => {
                                setUserData({ ...userData, isActive: event.target.checked });
                              }}
                              control={<IOSSwitch sx={{ m: 1 }} />}
                              checked={userData.isActive}
                            />
                            <span
                              style={{
                                height: "fit-content",
                              }}>
                              وضعیت دسترسی
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "10px",
                            }}>
                            <FormControlLabel
                              sx={{ m: 0 }}
                              onChange={event => {
                                setUserData({ ...userData, isShowEstates: event.target.checked });
                              }}
                              control={<IOSSwitch sx={{ m: 1 }} />}
                              checked={userData.isShowEstates}
                            />
                            <span
                              style={{
                                height: "fit-content",
                              }}>
                              وضعیت نمایش آگهی‌ها
                            </span>
                          </div>
                        </div>

                        <div className="d-flex justify-content-end align-items-center mt-4 mb-2" style={{ gap: "20px" }}>
                          <div
                            className={`${styles.total_delete_btn} text-center d-flex justify-content-center align-items-center ms-4`}
                            role="button"
                            onClick={() =>
                              setShowModal(prev => {
                                return { ...prev, openRemove: true };
                              })
                            }>
                            <img className={`ps-2 ms-1`} src={deleteIconRed} alt="delete-form-icon" width={`25`} />
                            <button style={{ color: "#e00000" }} className={`border-0 bg-transparent`}>
                              حذف
                            </button>
                          </div>
                          {btnLoader ? (
                            <div className={Dstyles.btn_loader_container}>
                              <div className={Dstyles.btn_spinner}></div>
                            </div>
                          ) : (
                            <div
                              className={`${styles.total_save_btn} text-center d-flex justify-content-center align-items-center me-4`}
                              role="button"
                              onClick={updateConsultant}>
                              <button className={`border-0 bg-transparent text-white`}>ذخیره</button>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu managePersonal manageStaffInfo />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function handleDownload() {
    setCursor("wait");
    const fileType = formStaffColleaguesInfo.CV.split(".");
    try {
      const response = await axios({
        url: `https://backdev.azrmelk.com/api/Consultant/DownloadFile/${formStaffColleaguesInfo.CV}`,
        method: "GET",
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `file.${fileType[1]}`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      notify("فایل یافته نشد", "error");
    }
    setCursor("pointer");
  }

  // Checked And Unchecked Area / Accsess Level
  function statusCheckAreaHandler(id, type) {
    if (type === "category") {
      let newCheckStaffArea = categories.map(item => {
        if (item.id === id) {
          return { ...item, selected: !item.selected };
        } else {
          return item;
        }
      });
      setCategories(newCheckStaffArea);
    } else {
      let newCheckStaffArea = checkStaffArea.map(item => {
        if (item.id === id) {
          return { ...item, isCheck: !item.isCheck };
        } else {
          return item;
        }
      });
      setCheckStaffArea(newCheckStaffArea);
    }
  }

  function deleteCheckAreaHandler(id, type) {
    if (type === "category") {
      let deleteCheckStaffArea = categories.map(item => {
        if (item.id === id) {
          return { ...item, selected: false };
        } else {
          return item;
        }
      });
      setCategories(deleteCheckStaffArea);
    } else {
      // console.log("object2")
      let deleteCheckStaffArea = checkStaffArea.map(item => {
        if (item.id === id) {
          return { ...item, isCheck: false };
        } else {
          return item;
        }
      });
      setCheckStaffArea(deleteCheckStaffArea);
    }
  }

  function statusRoleCheckAreaHandler(id) {
    let newCheckStaffArea = roles?.map(item => {
      if (item.id === id) {
        if (item.isCheck === true) {
          removeRole(item.id);
        }
        return { ...item, isCheck: !item.isCheck };
      } else {
        return item;
      }
    });
    setRoles(newCheckStaffArea);
  }

  function deleteRoleCheckAreaHandler(id) {
    let deleteCheckStaffArea = roles?.map(item => {
      if (item.id === id) {
        removeRole(item.id);
        return { ...item, isCheck: false };
      } else {
        return item;
      }
    });
    setRoles(deleteCheckStaffArea);
  }

  async function removeRole(id) {
    var roleData = {
      userId: formStaffColleaguesInfo.id,
      roleId: id,
    };
    const removeRole = await axios.post("Users/RemoveUserRole", roleData, {
      headers: { authorization: "Bearer " + userToken },
    });
  }

  async function updateUserData() {
    console.log(userData);
    try {
      var data = new FormData();
      data.append("Id", userData.id);
      // data.append("Avatar", state?.avatarName || "");
      data.append("Name", userData.name);
      data.append("Family", userData.family);
      data.append("PhoneNumber", userData.callNumber);
      // data.append("Gender", userData.gender || "");

      // data.append("Email", userData.email || "");
      // data.append('ParentId', 0);
      data.append("isActive", userData.isActive);
      data.append("isShowEstates", userData.isShowEstates);

      await axios.put("Users", data, {
        headers: { authorization: "Bearer " + userToken },
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function updateConsultant() {
    try {
      setIsLoading(true);
      // const checkedRoles = await roles?.filter(item => item.isCheck);
      const checkedRoles = roles?.filter(({ isCheck }) => isCheck);
      const checkedRolesIDs = await checkedRoles?.map(item => item.id);
      const checkedItems = checkStaffArea?.filter(item => item.isCheck === true);
      const checkedCategories = categories?.filter(item => item.selected === true);
      var data = new FormData();
      data.append("UserId", formStaffColleaguesInfo.id);
      data.append("Email", formStaffColleaguesInfo.email);
      data.append("Address", formStaffColleaguesInfo.address);
      data.append("AboutMe", formStaffColleaguesInfo.aboutMe);
      data.append("Education", formStaffColleaguesInfo.education);
      data.append("NationalId", formStaffColleaguesInfo.nationalId);
      data.append("Birthdate", formStaffColleaguesInfo.formBirthDate);
      data.append("CvImageName", null);
      data.append("LandlinePhone", formStaffColleaguesInfo.landlinePhone ? formStaffColleaguesInfo.landlinePhone : "");
      for (const category of checkedCategories) {
        data.append("CustomKeys", category.id);
      }
      for (const category of checkedCategories) {
        data.append("CustomValues", category.title);
      }
      for (const status of checkedItems) {
        data.append("Keys", status.id?.toString());
      }
      for (const status of checkedItems) {
        data.append("Values", status.name);
      }
      var roleData = {
        userId: formStaffColleaguesInfo.id,
        roleIds: checkedRolesIDs,
      };

      const [apiData, addRole] = await Promise.all([
        axios.put("Consultant", data, { headers: { authorization: "Bearer " + userToken } }),
        checkedRolesIDs !== "" ? axios.post("Users/AddUserRole", roleData, { headers: { authorization: "Bearer " + userToken } }) : null,
        await updateUserData(),
      ]);

      // const apiData = await axios.put(
      //     "Consultant",
      //     data,
      //     {
      //         headers: { authorization: "Bearer " + userToken },
      //     }
      // );
      // console.log(apiData)

      // if (checkedRolesIDs != "") {
      //     var roleData = {
      //         "userId": formStaffColleaguesInfo.id,
      //         "roleIds": checkedRolesIDs
      //     }

      //     const addRole = await axios.post(
      //         "Users/AddUserRole",
      //         roleData,
      //         {
      //             headers: { authorization: "Bearer " + userToken },
      //         }
      //     );
      // }

      notify("عملیات با موفقیت انجام شد", "success");
    } catch (error) {
      notify("خطایی رخ داد", "error");
      // console.log(error)
    }
    setIsLoading(false);
  }
};

export default StaffColleaguesInfoCardDetail;
